// extracted by mini-css-extract-plugin
module.exports = {"feedbackMenu":"style_feedbackMenu__LHcLW","reportWeb":"style_reportWeb__wmvsU","feedbackBtn":"style_feedbackBtn__fxN0M","reasonModal":"style_reasonModal__34YO6"};